"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseQuery = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.BaseQuery = typebox_1.Type.Object({
    limit: typebox_1.Type.Optional(typebox_1.Type.Integer({ minimum: 1 })),
    offset: typebox_1.Type.Optional(typebox_1.Type.Integer({ minimum: 0 })),
    orderBy: typebox_1.Type.Optional(typebox_1.Type.String()),
    reverseSort: typebox_1.Type.Optional(typebox_1.Type.Boolean()),
});
//# sourceMappingURL=base-query.js.map